const breakpoint = (callback) => {
  let isMobile = window.innerWidth < 1550;

  window.addEventListener("resize", () => {
    const isMobileCheck = window.innerWidth < 1500;

    if (isMobile !== isMobileCheck) {
      isMobile = isMobileCheck;
      callback();
    }

    isMobile = isMobileCheck;
  });
};

export default breakpoint;
